__turbopack_context__.v({
  "icon": "hamburger-menu-button-module-scss-module__ftEiuG__icon",
  "navIcon": "hamburger-menu-button-module-scss-module__ftEiuG__navIcon",
});
